import { render, staticRenderFns } from "./LabelsInput.vue?vue&type=template&id=434fc73a&scoped=true&"
import script from "./LabelsInput.vue?vue&type=script&lang=js&"
export * from "./LabelsInput.vue?vue&type=script&lang=js&"
import style0 from "./LabelsInput.vue?vue&type=style&index=0&id=434fc73a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434fc73a",
  null
  
)

export default component.exports